import React from 'react';

/**
 * Matches students-app Illustration: Classwise mark with floating accent dots.
 */
export default function HomeIllustration() {
  return (
    <div className="home-illustration relative mb-6 flex items-center justify-center px-4 md:mb-10">
      <div className="relative flex items-center justify-center">
        <img
          src="/assets/images/classwise-full-logo.png"
          alt=""
          className="h-[90px] w-[140px] object-contain md:h-[110px] md:w-[170px]"
          width={140}
          height={90}
        />
        <span
          aria-hidden
          className="home-illustration-dot home-illustration-dot--blue absolute -right-2 -top-2 h-4 w-4 rounded-full bg-blue-400"
        />
        <span
          aria-hidden
          className="home-illustration-dot home-illustration-dot--green absolute -bottom-1 -left-2 h-3 w-3 rounded-full bg-green-400"
        />
      </div>

      <style>{`
        .home-illustration {
          animation: home-illustration-enter 0.8s ease forwards;
        }
        .home-illustration-dot--blue {
          animation: home-illustration-blue 6s ease-in-out infinite;
        }
        .home-illustration-dot--green {
          animation: home-illustration-green 7s ease-in-out 0.8s infinite;
        }
        @keyframes home-illustration-enter {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes home-illustration-blue {
          0%, 100% { transform: translateY(0) scale(0.8); opacity: 0.7; }
          50% { transform: translateY(-8px) scale(1); opacity: 1; }
        }
        @keyframes home-illustration-green {
          0%, 100% { transform: translateY(0) scale(0.8); opacity: 0.7; }
          50% { transform: translateY(8px) scale(1); opacity: 1; }
        }
        @media (prefers-reduced-motion: reduce) {
          .home-illustration,
          .home-illustration-dot--blue,
          .home-illustration-dot--green {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
